module.exports = __webpack_public_path__ + "static/media/logo-siemens-landscape.765b40dd.svg";